<template>
  <div class="rent-search-wrapper">
    <v-container>
      <v-row>
        <v-col>
          <span>
            <v-btn text color="blue" @click="goToRent">
              {{ pointSell.title }}
            </v-btn>
          </span>

          <span> | </span>

          <span>
            <v-btn text color="blue" @click="goToRent">
              {{ checkInDateFormated }} - {{ checkOutDateFormated }}
            </v-btn>
          </span>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col>
          <v-chip-group
            v-model="rentCategory"
            mandatory
            active-class="primary accent-4"
            column
          >
            <v-chip
              v-for="category in rentCategories"
              :key="category.id"
              label
              x-large
            >
              {{ category.title }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="product in products"
          :key="product.id"
        >
          <rent-product-card
            v-bind:product="product"
            v-on:bookProduct="bookProduct(product)"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
.rent-search-wrapper {
  backgroud-color: red;
}
</style>

<script>
import RentProductCard from "@/components/RentProductCard";
import moment from "moment";

export default {
  metaInfo: {
    title: "Půjčovna vybavení",
  },

  components: {
    RentProductCard,
  },

  async mounted() {
    console.log("mounted");

    if (
      this.$store.state.pointSell == null ||
      this.$store.state.appInstance == null ||
      this.$store.state.checkInDate == null ||
      this.$store.state.checkOutDate == null
    ) {
      console.log("Nesplnene prerekvizity");
      this.$router.push({ name: "rent" });
    } else {
      this.init();
    }
  },

  data() {
    return {
      rentCategory: 0,
      rentAgeGroup: null,
      rentGender: null,
    };
  },

  methods: {
    init() {
      this.$store.dispatch("loadListCategoriesAndProductsRent");
    },

    goToRent() {
      this.$router.push({ name: "rent" });
    },

    changeRentAgeGroup(ageGroup) {
      this.rentAgeGroup = ageGroup;
    },

    // zahaji proces bookovani
    bookProduct(product) {
      console.log(product);
      if (this.$store.state.user == null) {
        this.$emit("loginRequest");
      } else {
        this.$router.push({
          name: "rent-booking",
          params: { productId: product.id },
        });
      }
    },
  },

  computed: {
    location() {
      return this.$store.state.location;
    },

    pointSell() {
      if (this.$store.state.pointSell == null) {
        return "";
      }
      return this.$store.state.pointSell;
    },

    checkInDate() {
      return this.$store.state.checkInDate;
    },

    checkOutDate() {
      return this.$store.state.checkOutDate;
    },

    checkInDateFormated() {
      if (this.checkInDate == null) {
        return "";
      }
      return moment(this.checkInDate).format("D. M. YYYY");
    },

    checkOutDateFormated() {
      if (this.checkOutDate == null) {
        return "";
      }
      return moment(this.checkOutDate).format("D. M. YYYY");
    },

    length() {
      return moment(this.checkOutDate).diff(this.checkInDate, "days") + 1;
    },

    rentCategories() {
      return this.$store.state.rentCategories;
    },

    products: function () {
      try {
        console.log("produkty na ceste");
        let productsFiltered = [];
        let products =
          this.$store.state.rentCategories[this.rentCategory].products.items;
        for (let i = 0; i < products.length; i++) {
          let product = products[i];
          //console.log(i);
          //console.log(product);
          let loc = product.locations.items.filter(
            (l) => l.location.id === this.pointSell.location.id
          );
          //console.log(loc);
          if (loc.length > 0) {
            productsFiltered.push(product);
          }
        }
        return productsFiltered;
      } catch (error) {
        console.log("products jeste nejsou k dispozici");
        return [];
      }
    },
  },
};
</script>
